import { render } from "./InvertedRedButton.vue?vue&type=template&id=f8c2a912"
import script from "./InvertedRedButton.vue?vue&type=script&lang=js"
export * from "./InvertedRedButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__